import React from "react"
import ReactDOM from "react-dom"
import GuideAccordion from "./guide-accordion-component"

export default class GuideAccordionModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<GuideAccordion {...self.modelJson} />, self.elem)
  }
}
